import React, { useEffect, useState } from "react"

import * as s from "./ChristmasHeader.module.scss"

import XmasHeader from "@assets/images/christmas-header/bg.jpg"

import One from "@assets/images/christmas-header/1.png"
import Two from "@assets/images/christmas-header/2.png"
import Three from "@assets/images/christmas-header/3.png"

export const ChristmasHeader = () => {
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    setLoaded(true)
  }, [])

  return (
    <div className={s.Header}>
      <img src={XmasHeader} />

      <img
        src={One}
        className={`${s.Frame} ${s.Frame__one}  ${
          loaded && s.Frame__one___loaded
        }`}
      />
      <img
        src={Two}
        className={`${s.Frame} ${s.Frame__two} ${
          loaded && s.Frame__two___loaded
        }`}
      />
      <img
        src={Three}
        className={`${s.Frame} ${s.Frame__three} ${
          loaded && s.Frame__three___loaded
        }`}
      />
    </div>
  )
}
